export default __webpack_public_path__ + "static/media/centricLogo.15dfafd9.png";